/**
 * Maps sidebar menu item IDs to HTML feature descriptions shown in the lock popover.
 * Leave the value as an empty string if no description is needed for that item.
 */
export const SIDEBAR_FEATURE_DESCRIPTIONS: Record<string, string> = {
  'affiliate-programs': '',
  'campaigns': '',
  'post-checkout': `
    <p class="text-muted-foreground leading-relaxed mb-3">
      Turn every customer into a potential affiliate right after they buy. Show a customizable <strong class="text-foreground">thank-you banner</strong> on your order confirmation page that invites them to join your program.
    </p>
    <ul class="space-y-2 text-muted-foreground text-sm list-none pl-0">
      <li class="flex items-start gap-2">
        <span class="inline-block w-1.5 h-1.5 rounded-full bg-brand-500 mt-1.5 flex-shrink-0"></span>
        <span>Unique referral & discount codes for each new signup</span>
      </li>
      <li class="flex items-start gap-2">
        <span class="inline-block w-1.5 h-1.5 rounded-full bg-brand-500 mt-1.5 flex-shrink-0"></span>
        <span>Set commission and discount (percentage or fixed) for post-checkout referrals</span>
      </li>
      <li class="flex items-start gap-2">
        <span class="inline-block w-1.5 h-1.5 rounded-full bg-brand-500 mt-1.5 flex-shrink-0"></span>
        <span>Dedicated <strong class="text-foreground">Post-Checkout Sales</strong> view: revenue, commissions, and orders</span>
      </li>
      <li class="flex items-start gap-2">
        <span class="inline-block w-1.5 h-1.5 rounded-full bg-brand-500 mt-1.5 flex-shrink-0"></span>
        <span>Seamless migration into your main affiliate program when they sign up</span>
      </li>
    </ul>
    <p class="text-muted-foreground text-xs mt-3 italic">
      Custom banner layout, social links, and &quot;Get my referral link&quot; CTA — all in one flow.
    </p>
  `,
  'affiliates': '',
  'products': '',
  'payouts': '',
  'share-resources': '',
  'compliance': `
    <p class="text-muted-foreground leading-relaxed mb-3">
      Stay compliant with <strong class="text-foreground">tax reporting</strong> for affiliate payouts. Collect and manage W-9 (US) and W-8BEN (non-US) forms from your affiliates in one place.
    </p>
    <ul class="space-y-2 text-muted-foreground text-sm list-none pl-0">
      <li class="flex items-start gap-2">
        <span class="inline-block w-1.5 h-1.5 rounded-full bg-brand-500 mt-1.5 flex-shrink-0"></span>
        <span>View affiliate tax profiles by tax year with legal name, entity type, and tax ID</span>
      </li>
      <li class="flex items-start gap-2">
        <span class="inline-block w-1.5 h-1.5 rounded-full bg-brand-500 mt-1.5 flex-shrink-0"></span>
        <span>Securely reveal full tax IDs and export to CSV for 1099 preparation</span>
      </li>
      <li class="flex items-start gap-2">
        <span class="inline-block w-1.5 h-1.5 rounded-full bg-brand-500 mt-1.5 flex-shrink-0"></span>
        <span>Re-authentication required to view or export — keeps sensitive data protected</span>
      </li>
    </ul>
    <p class="text-muted-foreground text-xs mt-3 italic">
      Under Payouts → Compliance. Essential for US brands paying affiliates over threshold.
    </p>
  `,
  'email-automation': '',
};

export function getMenuItemDescription(menuItemId: string): string | null {
  const desc = SIDEBAR_FEATURE_DESCRIPTIONS[menuItemId];
  return desc ? desc : null;
}
